<template>
    <b-modal v-if="!loading" id="concern_form" ref="concern_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            {{ !edit ? 'Add New Concern' : 'Edit Concern' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form @submit.prevent="submitConcern">
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>
                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? (delete errors.name) : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!('name' in errors)"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('concern_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitConcern">Submit</state-button>

            <state-button v-else variant="primary" :click="updateConcern">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "ConcernFormModal",

    components: {
        StateButton,
    },

    props: [
        'edit'
    ],

    data() {
        return{
            loading: true,
        }
    },

    computed: {
        ...mapGetters({
            form: 'getConcernForm',
            errors: 'getConcernErrors',
        })
    },

    mounted() {
        this.loading = false;
    },

    methods: {
        resetForm() {
            this.$store.commit('setConcernForm');
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitConcern() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitConcern', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new concern!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('concern_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateConcern() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateConcern', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the concern!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('concern_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
